import { gql } from "@apollo/client";

export const DELETE_DOCUMENTO_ESTUDIO_RI = gql`
mutation DeleteDocumentoRi(
   $input: AddDocumentoLaboratoriInput!
) {
    deleteDocumentoEstudioRI(
        input: $input
    )
}
`;